'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgNextCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M6 0C2.688 0 0 2.688 0 6s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6zm1.171 8.807l-.044.047a.612.612 0 01-.843-.047L4.038 6.453a.66.66 0 010-.907l2.246-2.354a.609.609 0 01.84-.044l.003-.003.044.047-.002.002a.66.66 0 01-.04.855l-1.862 1.95L7.13 7.95a.66.66 0 01.038.853l.004.004z", id: "Next-circle__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", transform: "rotate(180 6 6)", xlinkHref: "#Next-circle__svg__a" })))));
}

module.exports = SvgNextCircle;
//# sourceMappingURL=NextCircle.js.map
